import { render } from "./BaseRoute.vue?vue&type=template&id=4b26c697&scoped=true"
import script from "./BaseRoute.vue?vue&type=script&lang=js"
export * from "./BaseRoute.vue?vue&type=script&lang=js"

import "./BaseRoute.vue?vue&type=style&index=0&id=4b26c697&scoped=true&lang=css"

import exportComponent from "C:\\project\\webtrackandtrace\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b26c697"]])

export default __exports__